import { InjectionToken } from '@angular/core';
import { LogLevelEnum } from '../../enums/log-level/log-level.enum';

export const LOG_LEVEL = new InjectionToken<LogLevelEnum>('logLevel');
